module.exports = __webpack_public_path__ + "img/Legal-Instant-Translation-Logo.8c2ed7e3.png";